import { FC, SVGProps } from 'react'

export const IconUnavailable: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
      fill="url(#paint0_linear_8924_211267)"
      stroke="url(#paint1_linear_8924_211267)"
      strokeLinecap="square"
    />
    <g filter="url(#filter0_d_8924_211267)">
      <path
        d="M16 8L8 16M8 8L16 16"
        stroke="#D9253B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8924_211267"
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.85098 0 0 0 0 0.145098 0 0 0 0 0.231373 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8924_211267"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8924_211267"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_8924_211267"
        x1="12"
        y1="2"
        x2="12"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9253B" stopOpacity="0.18" />
        <stop offset="1" stopColor="#D9253B" stopOpacity="0.08" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8924_211267"
        x1="12"
        y1="2"
        x2="12"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9253B" stopOpacity="0.24" />
        <stop offset="1" stopColor="#D9253B" stopOpacity="0.04" />
      </linearGradient>
    </defs>
  </svg>
)
